import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";
import "@/styles/meme-switch.css";

function MemeSwitch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                "peer data-[state=checked]:bg-input data-[state=unchecked]:bg-input inline-flex h-11 p-0.5 w-22 shrink-0 items-center rounded-full border border-muted shadow-xs transition-all outline-none disabled:cursor-not-allowed",
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    `group bg-input data-[state=unchecked]:bg-muted-foreground h-full data-[state=uchecked]:border-muted-foreground border items-center h-fill data-[state=checked]:bg-primary pointer-events-none flex w-fit min-w-fit rounded-full ring-0  duration-300 ease-in-out data-[state=checked]:translate-x-[calc(100%-62px)] data-[state=unchecked]:translate-x-[0]`,
                )}
            >
                <span
                    className={cn(
                        "flex p-0 h-fit w-18 items-center leading-1 justify-center text-sm group-data-[state=unchecked]:opacity-60 !group-hover:opacity-100",
                    )}
                >
                    MEME
                </span>
            </SwitchPrimitive.Thumb>
        </SwitchPrimitive.Root>
    );
}

export { MemeSwitch };

// [#202326]
